/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PossibleAnswerDto
 */
export interface PossibleAnswerDto {
    /**
     * Possible answer unique identifier
     * @type {string}
     * @memberof PossibleAnswerDto
     */
    id?: string;
    /**
     * Answer key/code
     * @type {string}
     * @memberof PossibleAnswerDto
     */
    key?: string;
    /**
     * Answer label/text
     * @type {string}
     * @memberof PossibleAnswerDto
     */
    label?: string;
    /**
     * Type of value for this answer
     * @type {string}
     * @memberof PossibleAnswerDto
     */
    valueType?: string;
    /**
     * Display order of the answer
     * @type {number}
     * @memberof PossibleAnswerDto
     */
    displayOrder?: number;
    /**
     * Icon key for the answer
     * @type {string}
     * @memberof PossibleAnswerDto
     */
    iconKey?: string | null;
    /**
     * Whether this answer has child answers
     * @type {boolean}
     * @memberof PossibleAnswerDto
     */
    hasChildren?: boolean;
    /**
     * Additional data for the answer value
     * @type {object}
     * @memberof PossibleAnswerDto
     */
    valueData?: object | null;
}

/**
 * Check if a given object implements the PossibleAnswerDto interface.
 */
export function instanceOfPossibleAnswerDto(value: object): value is PossibleAnswerDto {
    return true;
}

export function PossibleAnswerDtoFromJSON(json: any): PossibleAnswerDto {
    return PossibleAnswerDtoFromJSONTyped(json, false);
}

export function PossibleAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossibleAnswerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'key': json['key'] == null ? undefined : json['key'],
        'label': json['label'] == null ? undefined : json['label'],
        'valueType': json['valueType'] == null ? undefined : json['valueType'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'hasChildren': json['hasChildren'] == null ? undefined : json['hasChildren'],
        'valueData': json['valueData'] == null ? undefined : json['valueData'],
    };
}

export function PossibleAnswerDtoToJSON(json: any): PossibleAnswerDto {
    return PossibleAnswerDtoToJSONTyped(json, false);
}

export function PossibleAnswerDtoToJSONTyped(value?: PossibleAnswerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'key': value['key'],
        'label': value['label'],
        'valueType': value['valueType'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'hasChildren': value['hasChildren'],
        'valueData': value['valueData'],
    };
}

